import { render, staticRenderFns } from "./serviceFive.vue?vue&type=template&id=5b132d12&"
import script from "./serviceFive.vue?vue&type=script&lang=js&"
export * from "./serviceFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports